import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import AvatarsPage from './pages/AvatarsPage';
import BifrostPage from './pages/BifrostPage';
import NimaPage from './pages/NimaPage';
import PilotPage from './pages/PilotPage';
import UnityPage from './pages/UnityPage';
import ScottyPage from './pages/ScottyPage';
import PollioPage from './pages/PollioPage';
import EcosystemPage from './pages/EcosystemPage';
import HomeEcosystemPage from './pages/HomeEcosystemPage';
import RoadmapPage from './pages/RoadmapPage';
import '@questlabs/react-sdk/dist/style.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/avatars" element={<AvatarsPage />} />
        <Route path="/bifrost" element={<BifrostPage />} />
        <Route path="/nima" element={<NimaPage />} />
        <Route path="/pilot" element={<PilotPage />} />
        <Route path="/unity" element={<UnityPage />} />
        <Route path="/scotty" element={<ScottyPage />} />
        <Route path="/pollio" element={<PollioPage />} />
        <Route path="/ecosystem" element={<EcosystemPage />} />
        <Route path="/home-ecosystem" element={<HomeEcosystemPage />} />
        <Route path="/roadmap" element={<RoadmapPage />} />
      </Routes>
    </Router>
  );
}

export default App;